module.exports = __webpack_public_path__ + "e-learning-app/static/img/dbkl.b14ae96.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/dbkl.png
// module id = 3gd7
// module chunks = 1